import {Component, Vue, Watch} from 'vue-property-decorator'
import { ArrayHelpers } from "@common/ArrayHelpers";

interface ParticipantListInterface {
    participantsContainer: any;
    participantsField: string;
    excludeParticipants: number[];
}

@Component
class ParticipantListMixin extends Vue {
    speakersLimit = 3;
    showAll = false;
    //@todo consider to remove the container and the field mixin props. Subs them to one get field, which returns users list for better typing
    participantsContainer: any;
    participantsField: string;
    excludeParticipants: number[] = [];

    get allSpeakers() {
        return ArrayHelpers.uniqBy(this.participantsContainer[this.participantsField].filter((item: any) => this.excludeParticipants.indexOf(item.userId) === -1), (item: any) => item.userId);
    }

    get speakers() {
        if (this.showAll) {
            return this.allSpeakers;
        }
        return this.speakersLimit > 0 ? this.allSpeakers.slice(0, this.speakersLimit) : this.allSpeakers;
    }

    get speakersMoreAmount(): number {
        return (this.allSpeakers.length as number) - this.speakersLimit;
    }

    get speakersClass() {
        return (this.allSpeakers.length as number) > 2 ? 'is-inline' : '';
    }

    showSpeaker(event: MouseEvent, userId: number) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.$emit('showProfile', userId);
    }

    toggleShowAll(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.showAll = !this.showAll;
    }
}

export { ParticipantListMixin, ParticipantListInterface }